import { type ReactNode } from 'react';
import { cn } from '../../lib/cn';

type Tone = 'success' | 'info' | 'danger';

interface BannerProps {
  tone?: Tone;
  icon?: ReactNode;
  title?: ReactNode;
  children?: ReactNode;
  className?: string;
}

const tones: Record<Tone, string> = {
  success: 'bg-accent-soft text-accent-fg',
  info: 'bg-surface-elevated text-text border-border',
  danger: 'bg-danger-soft text-danger',
};

export function Banner({ tone = 'info', icon, title, children, className }: BannerProps) {
  return (
    <div
      role="status"
      className={cn(
        'flex items-start gap-3 rounded-xl border border-transparent px-4 py-3 text-sm',
        tones[tone],
        className,
      )}
    >
      {icon && <span className="mt-0.5 shrink-0">{icon}</span>}
      <div className="min-w-0">
        {title && <div className="font-medium">{title}</div>}
        {children && <div className={cn(title && 'mt-0.5 opacity-90')}>{children}</div>}
      </div>
    </div>
  );
}
